/**
 * itprocessreducer.js
 **/

import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export function itProcessReducer(state = initialState.itapplication, action) {
	switch (action.type) {
		case types.UPDATE_ITPROCESS: {
			return action.response || state;
		}
		default:
			return state;
	}
}
